<div style="width:100%;height:450px">
  <iframe [src]='sanitizedUrl' style="width:100%;height:450px"></iframe>
</div>
